import CelebrationWinsMediator from 'Mediator/celebration-wins-mediator';
import { DOPrompts } from 'names/do-names';
import { DimSymbolsCommand } from 'slotworks/commands/symbols/dim-symbols-command';
import { HighlightSymbolsCommand } from 'slotworks/commands/symbols/highlight-symbols-command';
import { StaticSymbolsCommand } from 'slotworks/commands/symbols/static-symbols-command';
import Components from 'slotworks/components/components';
import SymbolComponent from 'slotworks/components/matrix/symbol/symbol-component';
import PromptContent from 'slotworks/components/prompt/prompt-content';
import Layers from 'slotworks/graphics/layers/layers';
import GameState from 'slotworks/model/game-state';
import SmartButton, { SmartButtonFlag } from 'slotworks/smart-button/smart-button';
import soundManager from 'slotworks/sound/sound-manager';
import { StateMachine } from 'slotworks/state-machine/state-machine';
import State from 'slotworks/state-machine/states/state';
import { parallel } from 'slotworks/utils/race-utils';

export default class ReTriggerFreeSpin extends State {
    private symbol: string;

    constructor(stateMachine: StateMachine, symbol: string) {
        super(stateMachine);
        this.symbol = symbol;
    }

    public onEnter() {
        const record = GameState.getCurrentGame().getCurrentRecord();
        Components.matrix.resetSymbols();
        Components.matrix.resetSymbolPositions();

        const totalWin = GameState.getCurrentGame().totalCreditsWon;
        const raceFuncs = [];
        const allWinsMediator = new CelebrationWinsMediator();
        raceFuncs.push(() => allWinsMediator.start());

        let onDisplayComplete = () => {
            Components.celebrateWin.hide();
            Components.betBar.winnings.setWinnings(record.creditsWon, totalWin, 750);
        };

        const allSymbols = Components.matrix.getAllSymbols();
        let symbols = new Array<SymbolComponent>();

        for (const symbol of allSymbols) {
            if (symbol.symbolId === this.symbol) {
                symbols.push(symbol);
            }
        }

        parallel(raceFuncs).then(() => {
            onDisplayComplete();
            DimSymbolsCommand(allSymbols).execute();
            HighlightSymbolsCommand(symbols).then(() => {
                StaticSymbolsCommand().execute();
                const prompt = new PromptContent([DOPrompts.RETRIGGER_FREESPIN], 1700);
                Layers.CelebrationBackground.setScene('freespins').execute();
                Components.prompt.showPrompt(prompt).then(() => {
                    Layers.CelebrationBackground.defaultScene().execute();
                    SmartButton.setFlag(SmartButtonFlag.PROMPT, false);
                    this.complete();
                });
            });
        });
        setTimeout(() => soundManager.customEvent('symbol_' + this.symbol + '_celebrate'), 500);
    }

    public complete() {
        super.complete();
    }
}



// WEBPACK FOOTER //
// ./src/states/retrigger-freespin.ts